type NavbarItem = {
  label: string;
  path: string;
}

const navbarList: NavbarItem[] = [
  {
    label: 'Formations',
    path: 'formation'
  },{
    label: 'Documents',
    path :'docs'
  },
  {
    label: 'Rapports',
    path: 'rapports'
  },
  // {
  //   label: 'Calendar',
  //   path :'calendrier'
  // },{
  //   label: 'Lexique',
  //   path :'lexique'
  // },

  {
    label: 'Passport',
    path :'passport'
  }
]

export {
  navbarList,
  NavbarItem
}
